
import http from '../HttpService'

const dataType = `permissions`
const baseService = http(dataType)
const additionalRequest = {}

export default Object.assign(baseService, additionalRequest)
